import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import userProfileImg from "../../../Assets/Images/General/avatar.jpg"


export default function UserNavProfile({ userData }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <Link aria-describedby={id} variant="text" to={""} onClick={handleClick} className='flex center nav-user nav-link dropdown-toggle'>
                <Box>
                    <img
                        alt="profile-user"
                        width="35px"
                        height="35px"
                        src={userProfileImg}
                        style={{ cursor: "pointer", borderRadius: "50%", marginRight: "10px" }} />
                </Box>
                <span className="pro-user-name flex">
                    {/* TODO:Add User name from db */}
                    <p> {userData.displayName}</p>
                    <i className="center mdi mdi-chevron-down"></i>
                </span>
            </Link>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                className='dropdown-menu  profile-dropdown'
            >
                <div >
                    <div className="dropdown-header">
                        <h6 className="text-overflow">Welcome!</h6>
                    </div>
                    <Link to="/profile" className="dropdown-item notify-item flex mt-1">
                        <span className="d-nav-icons">
                            <i className="fe-user"></i>
                        </span>
                        <span>My Account</span>
                    </Link>

                    <div className="dropdown-divider"></div>
                    <Link to="/auth/signout" className="dropdown-item notify-item flex">
                        <span className="d-nav-icons">
                            <i className="mdi mdi-logout"></i>
                        </span>
                        <span>Logout</span>
                    </Link>
                </div>
            </Popover>
        </div>
    );
}
